type FoldableLineItem = {
  id?: string | null;
  grossAmount: number | null;
  netAmount: number | null;
  isDeferredCostLine?: boolean;
  deferredFromLineItemId?: string | null;
};

const foldDeferredCostLines = <T extends FoldableLineItem>(
  lineItems: T[],
): (T & { deferredCostLine: T | null })[] =>
  lineItems
    .filter((lineItem) => !lineItem.isDeferredCostLine)
    .map((lineItem) => {
      const deferredCostLine =
        lineItems.find(
          (item) => item.isDeferredCostLine && item.deferredFromLineItemId === lineItem.id,
        ) ?? null;

      return {
        ...lineItem,
        deferredCostLine,
        grossAmount: (lineItem.grossAmount || 0) + (deferredCostLine?.grossAmount || 0),
        netAmount: (lineItem.netAmount || 0) + (deferredCostLine?.netAmount || 0),
      };
    });

export default foldDeferredCostLines;
